import type { RowData, Table } from './tanstack.js';

/** Represents the data engine for a table. */
export type TableEngine<TData extends RowData> = Table<TData>;
